export function fmtMSS(minutes?: number) {
  if (!minutes || minutes < 0) {
    return ''
  }

  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  let timeString = ''

  if (hours > 0) {
    timeString += hours + 'h'
  }

  if (remainingMinutes > 0) {
    if (timeString !== '') {
      timeString += ' '
    }
    timeString += remainingMinutes
    timeString += ' ' + 'min'
  }

  return timeString
}

export function fmtMSSeconds(seconds?: number) {
  if (!seconds || seconds < 0) {
    return ''
  }

  const hours = Math.floor(seconds / 3600)
  const remainingSeconds = seconds % 3600
  const minutes = Math.floor(remainingSeconds / 60)
  const remainingSecondsAfterMinutes = remainingSeconds % 60

  let timeString = ''

  if (hours > 0) {
    timeString += hours + 'h'
  }

  if (minutes > 0) {
    if (timeString !== '') {
      timeString += ' '
    }
    timeString += minutes + 'min'
  }

  if (remainingSecondsAfterMinutes > 0) {
    if (timeString !== '') {
      timeString += ' '
    }
    timeString += remainingSecondsAfterMinutes + 's'
  }

  return timeString
}
